export default class User {
    auth0Id: string;

    constructor(auth0Id: string) {
        this.auth0Id = auth0Id;
    }
}
